
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'CommonContextMenu',
  props: {
    containerId: {
      type: String,
      default: 'diagram-card-grid',
    },
    menuItems: {
      type: Array,
    },
    actions: {
      type: Object,
      default: {
        delete: 'delete',
      },
    },
    menuPositionX: {
      type: Number,
    },
    menuPositionY: {
      type: Number,
    },
    object: {
      type: Object,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('contextMenu', {
      visibleMenu: 'visibleMenu',
    }),
    id() {
      return this.containerId
    },
    globalIsVisible() {
      return this.$store.state.contextMenu.isVisible
    },
    target() {
      return this.$store.state.contextMenu.target
    },
    isUpdating: {
      get() {
        return this.$store.state.contextMenu.isUpdating
      },
      set(v: boolean) {
        this.$store.commit('contextMenu/setIsUpdating', v)
      },
    },
    isVisible: {
      get() {
        return this.visibleMenu[this.containerId]
      },
      set(v: boolean) {
        this.isVisible = v
      },
    },
  },
  watch: {
    visibleMenu: {
      handler(visibleMenu) {
        if (this.isVisible !== visibleMenu[this.containerId]) {
          this.isVisible = visibleMenu[this.containerId]
        }
      },
      deep: true,
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    menuItemClick(item: { [key: string]: string | null }): void {
      if (!item.action) {
        return
      }
      this.emitAction(item.action, this.object)
    },

    emitAction(action: string | null, diagram: any): void {
      this.$emit('menu-item-click', {
        action: action,
        diagram: diagram,
      })
    },

    handleClickOutside(): void {
      this.$emit('visibility-changed', false)
    },
  },
})
